<template>
    <FormModal :model="model" :init="init" modal-id="shipping_crobo_order" :beforeSaving="beforeSaving" @destroy="$emit('destroy', $event)" item-id="id" @shown="shown" :is-enabled-view-mode="false">
        <template v-slot:form="{ error: error }">
            <div v-for="value in error">
                <input-error :errors="value" />
            </div>

            <template>
                <LogTable
                    v-model="model.items"
                    :fields="[
                        { key: 'box', label: '梱包', thStyle: { width: '5em', }, },
                        { key: 'file', label: 'ラベルPDF', thStyle: { width: '15em', }, },
                        { key: 'pecs_prepend', label: '', thStyle: { width: '3em', }, },
                        { key: 'pecs', label: 'PEC', thStyle: { width: 'auto', }, },
                    ]"
                    :defaultRow="{
                        file: null,
                        pecs: [
                            { pec: null, quantity: 1, },
                        ],
                    }"
                    class="deal-items mt-3"
                    :showBtnRowMove="false"
                    :showBtnRowCopy="false"
                    :autoAddRow="true"
                    ref="logTable"
                    >
                    <template v-slot:cell(box)="{ item, index }">
                        梱包#{{ index + 1 }}
                    </template>
                    <template v-slot:cell(file)="data">
                        <b-form-file
                           v-model="data.item.file"
                            size="sm"
                            type="file"
                            @input="onInputFile($event, data.item)"
                            placeholder="選択されていません"
                            drop-placeholder="Drop file here..."
                            browse-text="選択"
                            style="height:2.45em;"
                            ></b-form-file>
                    </template>
<!--
                    <template v-slot:cell(pec)="data">
                        <b-form-textarea
                            v-model="data.item.pec"
                            placeholder="pec(改行区切)"
                            rows="1"
                            max-rows="30"
                            @focus="$event.target.select()"
                            ></b-form-textarea>
-->
<!--
                        <a href="#" @click="showModalOrderSearch(data.item)">eBay注文検索</a>
-->
<!--
                    </template>
-->
                    <template v-slot:cell(pecs_prepend)="{ item }">
                    </template>
                    <template v-slot:cell(pecs)="data">
                        <LogTable
                            v-model="data.item.pecs"
                            :fields="[
                                { key: 'number', label: '#', },
                                { key: 'pec', label: 'PEC', },
                                { key: 'quantity_prepend', label: '', },
                                { key: 'quantity', label: '数量', },
                            ]"
                            :defaultRow="{
                                pec: null,
                                quantity: 1,
                            }"
                            class="deal-items"
                            :showBtnRowMove="false"
                            :showBtnRowCopy="false"
                            :autoAddRow="true"
                            ref="logTable2"
                            thead-class="d-none"
                            style="margin-top: -6px;"
                            >
                            <template v-slot:table-colgroup>
                                <col width="3em" />
                                <col width="5em" />
                                <col />
                                <col width="1em" />
                                <col width="5em" />
                            </template>
                            <template v-slot:cell(number)="{ item, index }">
                                #{{ index + 1 }}
                            </template>
                            <template v-slot:cell(pec)="{ item }">
                                <b-form-input
                                    v-model="item.pec"
                                    placeholder="pec"
                                    @focus="$event.target.select()"
                                    />
                            </template>
                            <template v-slot:cell(quantity_prepend)="{ item }">
                                <div>x</div>
                            </template>
                            <template v-slot:cell(quantity)="{ item }">
                                <b-form-input
                                    v-model="item.quantity"
                                    type="number"
                                    min="1"
                                    placeholder="数量"
                                    @focus="$event.target.select()"
                                    style="width: 5em;"
                                    />
                            </template>
                            <template v-slot:addRowButton>
                                PECを追加
                            </template>
                        </LogTable>
                    </template>
                    <template v-slot:addRowButton>
                        梱包を追加
                    </template>
                </LogTable>

                <b-modal
                    id="modal-order-search"
                    size="lg"
                    title="eBay注文検索"
                    @ok="purifySkuSelected(); item_editing.pec = sku_selected"
                    >
                    <b-row>
                        <b-col cols="9" xl="10">
                            <div class="d-flex align-items-end mb-2">
                                <div class="flex-grow-1"
                                    v-if="auth_level >= '200'"
                                    >
                                    <small>利用者</small>
                                    <SelectUserInGroup
                                        v-model="order_user_id"
                                        :me="true"
                                        />
                                </div>
                                <div class="flex-grow-1">
                                    <small>SKU, 注文番号</small>
                                    <b-form-input v-model="order_query" @keydown.enter.native="fetchOrders"></b-form-input>
                                </div>
                                <div class="flex-shrink-1">
                                    <b-button
                                        variant="secondary"
                                        @click="fetchOrders"
                                        >
                                        検索
                                    </b-button>
                                </div>
                            </div>

                            <ShippingEcmsTable
                                ref="table"
                                mode="read"
                                @click-select-data="onClickSelectData"
                                />

                        </b-col>
                        <b-col cols="3" xl="2">
                            <small>選択中</small>
                            <b-form-textarea
                                v-model="sku_selected"
                                placeholder="pec(改行区切)"
                                rows="1"
                                max-rows="30"
                                @focus="$event.target.select()"
                                ></b-form-textarea>
                        </b-col>
                    </b-row>
                </b-modal>

<!--
                <div class="text-center my-3">
                    <a href="#table_check_section" class="blink text-decoration-none">
                        <div style="font-size: 1.5em;">{{ data_selected.length }}件選択</div>
                        <div style="height: 40px; overflow: hidden;">
                            <font-awesome-icon icon="caret-down" class="fa-fw" style="font-size: 7em; margin-top: -35px;" />
                        </div>
                    </a>
                </div>

                <div class="p-3 mb-3 bg-light" id="table_check_section">
                    <strong>Step2. データ調整</strong>
                </div>

                <ShippingEcmsTable ref="table_check" mode="create" />
-->

            </template>




            <br>
            <br>
            <br>
            <br>
            <br>
            <br>
            <br>

        </template>
    </FormModal>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import FormModal from '@/components/FormModal.vue'
import ItemBadges from '@/components/ItemBadges.vue'
import InputError from '@/components/InputError.vue'
import GridPage from '@/components/GridPage.vue'
import AddressSearch from '@/components/AddressSearch.vue'
import AddressContent from '@/components/AddressContent.vue'
import BoxContent from '@/components/BoxContent.vue'
import ItemContent from '@/components/ItemContent.vue'
import InsuranceContent from '@/components/InsuranceContent.vue'
import VatContent from '@/components/VatContent.vue'
import InvoiceContent from '@/components/InvoiceContent.vue'
import CourierContent from '@/components/CourierContent.vue'
import CourierSupplement from '@/components/CourierSupplement.vue'
//import LogTable from '@/components/LogTable.vue'
//import ShippingTable from '@/components/ShippingTable.vue'
import SelectCurrencyId from '@/components/SelectCurrencyId.vue'
import SelectUserInGroup from '@/components/SelectUserInGroup.vue'
import ShippingEcmsTable from '@/components/ShippingEcmsTable.vue'
import LogTable from '@/components/LogTable.vue'

export default {
    components: {
        GridPage,
        FormModal,
        ItemBadges,
        AddressSearch,
        AddressContent,
        BoxContent,
        ItemContent,
        InsuranceContent,
        VatContent,
        InvoiceContent,
        CourierContent,
        CourierSupplement,
//        LogTable,
//        ShippingTable,
        SelectCurrencyId,
        SelectUserInGroup,
        InputError,

        ShippingEcmsTable,
        LogTable,
    },
    emits: [
        'save',
        'destroy',
    ],
    props: {
        model: {
            type: Object,
            required: true,
            default() {
                return null
            },
        },
        init: {
            type: Function,
            default() {
                return null
            },
        },
    },
    data() {
        return {
            key: 0,

//            data: {
//            },
            sku_selected: '',
            item_editing: null,

            order_user_id: null,
            order_query: '',
            order_provider: '',
            order_type: 'word',
            data_orders: [],
//            data_orders_selected_currency: 'USD',
        }
    },
    computed: {
        ...mapGetters([
            'auth_uuid',
            'auth_id',
            'auth_level',
            'trim_address',
            'trans',
            'shipping_default',
            'dimensional_weight',
            'create_shipping',
            'filter4address',
        ]),
    },
    mounted() {
//        this.timer = window.setInterval(this.interval, 10 * 1000)
//        this.interval()
        this.shown()
    },
    destroyed() {
        clearInterval(this.timer)
    },
    methods: {
//        async saved (data, response) {
//            this.$emit('save', data)
//        },
        beforeSaving (model) {
            console.log('beforeSaving')
            console.log(model)
            let data = this.$utils.copy(model)
            return data
        },
        fetchOrders (provider_type) {
console.log('fetchOrders')
            this.$utils.empty(this.data_orders)
            this.$store
                .dispatch('shipping/fetch_fulfillment_orders', {
                    order_user_id: this.order_user_id,
                    order_provider: this.order_provider,
                    order_type: this.order_type,
                    order_query: this.order_query,
                    order_shipped: '0',
                })
                .then((response) => {
//                    this.data_orders = response.data
//                    for (let i = 0; i < this.data_orders.length; i++) {
//                    }
console.log('response')
                    if (response.data && response.data.data && response.data.data.hits) {
console.log(response.data.data.hits)
                        this.$refs.table.loadData(response.data.data.hits)
                    } else {
console.log('[]')
                        this.$refs.table.loadData([])
                    }
                    this.$refs.table.setup()
                })
                .catch((error) => {
console.log('error')
console.log(error)
                })
        },
        shown () {
console.log('shown---------------------------')
            this.setDefaultValue()
        },
        async setDefaultValue () {
//            if (this.auth_level >= '200') {
//                this.order_user_id = null
//            } else {
//                this.order_user_id = this.auth_id
//            }
//            this.order_query = ''
//            this.order_provider = ''
//            this.order_type = 'word'
//            this.data_orders.splice(0)
////            this.data_orders_selected_currency = 'USD'
//
//console.log('setDefaultValue---------------------------')
//console.log(this.shipping_default)
//            this.$utils.set(this.data, this.shipping_default)
//
//            do {
//                await this.$utils.sleep(300)
//                this.$refs.table.loadData([])
//                this.$refs.table_check.loadData([])
//            } while (!this.$refs.table || !this.$refs.table_check)
        },
        onClickSelectData (row, individual = false) {
console.log('onClickSelectData')
console.log(row)
              this.sku_selected = [ this.sku_selected, row ].join('\n')
              this.purifySkuSelected()
        },
        purifySkuSelected() {
console.log('purifySkuSelected')
              this.sku_selected = this.sku_selected.replace(/^\s*$(?:\r?\n)?/gm, '')

              let skus = this.sku_selected.split('\n')
              let skus_purified = []
              for (let i = 0; i < skus.length; i++) {
                  let sku = skus[i].trim()
                  if (!sku) {
                      continue
                  }

                  let index = skus_purified.indexOf(sku)
                  if (index !== -1) {
                      skus_purified.splice(index, 1)
                  }
                  
                  skus_purified.push(sku)
              }

              this.sku_selected = skus_purified.join('\n')
        },





        pushDataSelected(row, individual = false) {
console.log('pushDataSelected', row, individual)
//console.log(this.$refs.hotTable.hotInstance.getSourceDataAtRow(row))
            
            const data = this.$utils.copy(row)
            if (!individual) {
                data = [ data ]
            }
            for (let i = 0; i < row.length; i++) {
                this.data_selected.push(data[i])
            }
console.log('this.data_selected')
console.log(this.data_selected)
const hot = this.$refs.table_check.$refs.hotTable.hotInstance
console.log(hot)
            hot.loadData(this.data_selected)
            this.$refs.table_check.setup()
        },
        onInputFile (file, item) {
            let name = file.name
            name = name.split('.')
            name.pop()
            name = name.join('.')

            if (item.pecs.length === 1 & !item.pecs[0].pec) {
//            if (!item.pec) {
                if (this.validatePec(name)) {
                    item.pecs[0].pec = name
//                    item.pec = name
                }
            }
        },
        showModalOrderSearch (item) {
//            this.data_selected.splice(0)
            this.item_editing = item
            this.sku_selected = item.pec
            this.$bvModal.show('modal-order-search')
        },
        validatePec (pec) {
            // PEC:A02250901001
            // - user_id:A02
            // - date:250901
            // - sequence:001

            if (typeof pec !== 'string') {
                console.log('pec is not string')
                return false
            }
            if (pec.length !== 12) {
                console.log('pec length must be 12')
                return false
            }

            let user_id = pec.substring(0, 3)
            let yymmdd = pec.substring(3, 9)
            let sequence = pec.substring(9, 12)


            // TODO
//            if (user_id !== ) {
//                console.log('pec user_id is invalid')
//                return false
//            }
            let yymmdd_obj = this.$moment(yymmdd, 'YYMMDD', true)
            if (!yymmdd_obj.isValid()) {
                console.log('pec date is invalid')
                return false
            }

            const regex = /^[0-9]{3}$/
            if (!regex.test(sequence)) {
                console.log('pec sequence is invalid')
                return false
            }

            return true
        },
    },
}
</script>

<style lang="scss" scoped>
.item-name {
    font-size: 1.6em;
    margin-bottom: 0;
}
.item-price {
    font-size: 1.6em;
    margin-bottom: 0;
}
.shipping-address-th {
    width:0.1%;
    white-space: nowrap;
}
</style>

